import { render, staticRenderFns } from "./UnavailableRecords.vue?vue&type=template&id=2ffde1c8&scoped=true&"
import script from "./UnavailableRecords.vue?vue&type=script&lang=js&"
export * from "./UnavailableRecords.vue?vue&type=script&lang=js&"
import style0 from "./UnavailableRecords.vue?vue&type=style&index=0&id=2ffde1c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffde1c8",
  null
  
)

export default component.exports